import React from 'react'
import { withTheme } from 'styled-components'
import PropTypes from 'prop-types'
import { IconWideAngleBracket } from 'secondstep-components'
import {
  AngleButton,
  ButtonsWrapper,
  Content,
  ContentImage,
  Wrapper,
  Footer,
  Header,
  HeaderTitle,
  Copy,
  CopyHeader,
  CopySubhead,
  CopyBody,
} from './component.styles'
import AccessibleTextLink from 'components/AccessibleTextLink'

const ImageCarousel = ({
  contentfulLesson,
  currentSlide,
  setCurrentSlide,
  theme,
}) => {
  let slide = contentfulLesson?.content?.[currentSlide] || {}
  const {
    bodyCopy = '',
    image = {},
    header = '',
    linkLabel = '',
    linkTo = {},
    subhead = '',
  } = slide

  return contentfulLesson ? (
    <Wrapper>
      <Header>
        <HeaderTitle>{contentfulLesson?.displayTitle}</HeaderTitle>
        <ButtonsWrapper>
          <AngleButton
            data-testid="image-carousel-previous-slide-button"
            disabled={currentSlide === 0}
            onClick={() => setCurrentSlide(--currentSlide)}
          >
            <IconWideAngleBracket color={theme?.colors?.white} rotate={180} />
          </AngleButton>
          <AngleButton
            data-testid="image-carousel-next-slide-button"
            disabled={currentSlide === contentfulLesson?.content?.length - 1}
            onClick={() => setCurrentSlide(++currentSlide)}
          >
            <IconWideAngleBracket color={theme?.colors?.white} />
          </AngleButton>
        </ButtonsWrapper>
      </Header>
      <Content>
        <ContentImage src={image?.file?.url} />
        <Copy>
          <CopySubhead>{subhead}</CopySubhead>
          <CopyHeader>{header}</CopyHeader>
          <CopyBody>{bodyCopy}</CopyBody>
        </Copy>
      </Content>
      <Footer>
        <AccessibleTextLink
          dataTestId="image-carousel-link"
          href={linkTo?.file?.file?.url}
        >
          {linkLabel}
        </AccessibleTextLink>
      </Footer>
    </Wrapper>
  ) : null
}

ImageCarousel.propTypes = {
  contentfulLesson: PropTypes.shape({
    displayTitle: PropTypes.string.isRequired,
    content: PropTypes.array.isRequired,
  }),
  currentSlide: PropTypes.number.isRequired,
  setCurrentSlide: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withTheme(ImageCarousel)
